/**
 * Format a number as AUD-style currency string (2 decimal places, comma separators).
 * Does not include the currency symbol -- callers prepend `currency` themselves.
 */
export const fmtAUD = (v) =>
  (Number(v) || 0).toLocaleString("en-AU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/**
 * Format a value with currency symbol, placing the minus sign before the symbol
 * for negative values (e.g. -$500.00 instead of $-500.00).
 */
export const fmtCurrency = (v, symbol = '$') => {
  const n = Number(v) || 0;
  return n < 0 ? '-' + symbol + fmtAUD(Math.abs(n)) : symbol + fmtAUD(n);
};

/**
 * Like fmtCurrency but rounds to whole dollars (no decimals).
 */
export const fmtCurrencyWhole = (v, symbol = '$') => {
  const n = Number(v) || 0;
  const abs = Math.abs(n).toFixed(0);
  return n < 0 ? '-' + symbol + abs : symbol + abs;
};

export const toMonthly = (amt, freq, customSchedule) => {
  const n = Number(amt) || 0;
  if (freq === "Weekly") return (n * 52) / 12;
  if (freq === "Fortnightly") return (n * 26) / 12;
  if (freq === "Quarterly") return n / 3;
  if (freq === "Annual") return n / 12;
  if (freq === "Custom" && customSchedule) {
    if (customSchedule.type === "every-n-weeks") {
      const weeks = Math.max(1, Number(customSchedule.intervalWeeks) || 2);
      return (n * 52) / (12 * weeks);
    }
    if (customSchedule.type === "nth-weekday-of-month") return n;
  }
  return n;
};
